import ProgressBarController from '../modules/ProgressBarController';
import QuizController from '../modules/QuizController';

export default {
  progressBarController: null,
  quizController: null,

  init() {
    this.progressBarController = new ProgressBarController();
    this.quizController = new QuizController;

    console.log('Initialized curate.js...');

    this.quizController.submitResults();
    this.progressBarController.delayedFill();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/curate.js